__turbopack_context__.v({
  "additionalInfoContainer": "iUF6Va_additionalInfoContainer",
  "additionalInfoCopy": "iUF6Va_additionalInfoCopy",
  "priceInfoCopy": "iUF6Va_priceInfoCopy",
  "priceLabelContainer": "iUF6Va_priceLabelContainer",
});
